const INVITATION_ACCEPT_PATH_PATTERN = /^\/invitations\/(?:accept|[^/]+\/accept)$/;

export function isInvitationAcceptPathname(pathname: string): boolean {
    const normalizedPathname = pathname.replace(/\/+$/, '') || '/';

    return INVITATION_ACCEPT_PATH_PATTERN.test(normalizedPathname);
}
